
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tv/guide",
      function () {
        return require("private-next-pages/tv/guide.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tv/guide"])
      });
    }
  